/* tslint:disable */
/* eslint-disable */
/**
 * Optimizely Feature Experimentation API
 * This page documents how to use the Optimizely FX API. With this API you can view and manage Feature Flags and all of their related entities including Variables, Variations, Rules, and Reports.  The base URL is https://api.optimizely.com/flags/v1. Append any paths listed in these docs onto that url in order to make requests to the API.
 *
 * The version of the OpenAPI document: 0.3.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RuleVariation
 */
export interface RuleVariation {
    /**
     * User-facing Unique identifier of the Variation
     * @type {string}
     * @memberof RuleVariation
     */
    key: string;
    /**
     * Id of the RuleVariation
     * @type {number}
     * @memberof RuleVariation
     */
    readonly id?: number;
    /**
     * User-facing name of the Variation
     * @type {string}
     * @memberof RuleVariation
     */
    name?: string;
    /**
     * The percentage of the designated audiences that should get this variation, measured in basis points. 100 basis points = 1% traffic
     * @type {number}
     * @memberof RuleVariation
     */
    percentage_included: number;
    /**
     * Revision number for tracking changes
     * @type {number}
     * @memberof RuleVariation
     */
    readonly revision?: number;
    /**
     * Id of variation
     * @type {number}
     * @memberof RuleVariation
     */
    variation_id?: number;
}

export function RuleVariationFromJSON(json: any): RuleVariation {
    return RuleVariationFromJSONTyped(json, false);
}

export function RuleVariationFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuleVariation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': json['key'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'percentage_included': json['percentage_included'],
        'revision': !exists(json, 'revision') ? undefined : json['revision'],
        'variation_id': !exists(json, 'variation_id') ? undefined : json['variation_id'],
    };
}

export function RuleVariationToJSON(value?: RuleVariation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'name': value.name,
        'percentage_included': value.percentage_included,
        'variation_id': value.variation_id,
    };
}


